import styled from 'styled-components';

export const ContainerDialog = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`